import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { isSwedish, isDanish, isNorwegian } from '../../constants/languages';

type EmailClaimButtonProps = {
  iimclient: ConfigClientType;
  linkUrl?: string;
};


const EmailClaimButton = ({ iimclient, linkUrl }: EmailClaimButtonProps) => {
  const { lang, segment } = iimclient;

  const isVertikalWithEmail = iimclient.novertikal && iimclient.floater_email_url;
  const callNumber = (isVertikalWithEmail ? iimclient.texts['call-number'] : '') || {};

  const segmentLink =
      segment && segment.floater_email_claimurl && segment.floater_email_claimurllabel;

  const serviceLink =
    (isSwedish(iimclient) || (isDanish(iimclient) && !segment) || iimclient.novertikal)
    && iimclient.floater_email_url
    && iimclient.texts['email-claim-button'];

  const hideLink = !(linkUrl || segmentLink || serviceLink || isNorwegian(iimclient));

  const link = hideLink
    ? ''
    : linkUrl
    ? linkUrl
    : segmentLink
    ? segment.floater_email_claimurl
    : serviceLink
    ? iimclient.floater_email_url
    : 'https://www.if.no/privat/kundeservice/skriv-til-oss/omforsikring';

  const clickEmailClaimButton = () =>
    (window as any).NordicTracking.eventOtherLink(
        false,
        (window as any).NordicTracking.PANELINFO_FUNCTION_NAME_EMAIL,
        link
    );

  return (
    <div>
      {!hideLink && (
        <a
        href={link}
        className="if button primary same-width"
        target="_blank"
        rel="noopener noreferrer"
        id="email-claim-button"
        role="button"
        onClick={clickEmailClaimButton}
        style={{
          backgroundColor: callNumber.bgcolor ? callNumber.bgcolor : '',
          color: callNumber.color ? callNumber.color + ' !important' : '',
        }}
        >
        {hideLink
          ? ''
          : segmentLink
          ? segment.floater_email_claimurllabel
          : iimclient.texts['email-claim-button']
          ? iimclient.texts['email-claim-button']
          : 'Om skade'}
        </a>
    )}
    </div>
  )
}

export default EmailClaimButton;
